var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3041 8.7137C23.0874 7.46036 24.9127 7.46036 25.6961 8.7137L42.0876 34.9401C42.9201 36.2722 41.9624 38.0001 40.3916 38.0001H7.60855C6.03768 38.0001 5.08 36.2722 5.91256 34.9401L22.3041 8.7137Z",
    fill: "#FFAA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 17.7143C26 16.6857 25.2 16 24 16C22.8 16 22 16.6857 22 17.7143V26.2857C22 27.3143 22.8 28 24 28C25.2 28 26 27.3143 26 26.2857V17.7143ZM24 30C22.896 30 22 30.896 22 32C22 33.104 22.896 34 24 34C25.104 34 26 33.104 26 32C26 30.896 25.104 30 24 30Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6aae7922c90b8d803eadf7eb58c68130.svg";
export { ForwardRef as ReactComponent };